import { FaRegStar, FaStar } from 'react-icons/fa'

interface StarRatingProps {
  rating: number
}

const StarRating = ({ rating }: StarRatingProps) => {
  return (
    <>
      {[...Array(5)].map((_, i) =>
        i < rating ? (
          <FaStar key={i} fontSize={18} className='text-[#093269]' />
        ) : (
          <FaRegStar key={i} fontSize={18} className='text-[#093269]' />
        ),
      )}
    </>
  )
}

export default StarRating
